import Immutable from 'immutable'
import { handleActions } from 'redux-actions'

export const SHOW_NOTICE = 'SHOW_NOTICE'
export const CLEAR_NOTICE = 'CLEAR_NOTICE'

export const showNotice = (payload, promise) => ({
  payload,
  promise,
  type: SHOW_NOTICE,
})
export const clearNotice = (payload, promise) => ({
  payload,
  promise,
  type: CLEAR_NOTICE,
})

const notice = handleActions(
  {
    [SHOW_NOTICE]: (state, action) => {
      const notice = action.hasOwnProperty('notice')
        ? action.notice
        : action.payload.notice

      return state.set('notice', notice)
    },
    [CLEAR_NOTICE]: state => state.set('notice', null),
  },
  Immutable.fromJS({
    notice: null,
  }),
)

export default notice
